//#region Lang And Currency
function changeSiteLanguage(langID, langCode) {

    var url = "/";
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";

    for (var i = 0; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    $.ajax({
        type: 'get',
        url: getRequestRoute() + '/p/Home/ChangePageLang',
        data: 'PID=' + $("#PID").val() + "&PgType=" + $("#PgType").val() + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + langID + ctlgs + "&langCode=" + langCode,
        success: function (dt) {
            window.parent.location.href = dt;
        }
    });

}

function ToggleFooterMenu() {
    $("footer .footmenus .bottomMenu.mobile-slide").click(function () {
        //$("footer .footmenus .bottomMenu.mobile-slide").not($(this).find("> ul")).find("> ul").slideUp();
        //$("footer .footmenus .bottomMenu.mobile-slide").not($(this)).removeClass("open");

        $(this).toggleClass("open");
        $(this).find("ul").slideToggle();
    });
}

function ShowLangAreaForChange() {
    var userLang = navigator.language || navigator.userLanguage;

    if (userLang != null && userLang != undefined && userLang.length > 2) {
        userLang = userLang.substr(0, 2).toLowerCase();
    }

    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/Home/ShowLangSwitch",
        success: function (data) {

            if ($(".LangSelectionArea").length <= 0) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }
            }
            else if ($(".LangSelectionArea").hasClass("gizle")) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".LangSelectionArea").show();
                }
            }
            else {
                $(".LangSelectionArea").hide();
            }
        }
    });
}

function ShowCurrencyForChange() {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/Home/ShowCurrencySwitch",
        success: function (data) {

            if ($(".CurrrencySelectionArea").length <= 0) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".CurrrencySelectionArea").hasClass("gizle")) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".CurrencySelectionArea").show();
                }


            } else {

                $(".CurrrencySelectionArea").hide();
            }

        }
    });

}

function CountryControlForModal() {
    if ($("#AnotherCountry").length > 0 && $("#AnotherCountry").val() != "False") {

        $("#AnotherCountryModal").modal({
            keyboard: false,
            handleUpdate: false,
            backdrop: 'static'
        });
    }

    $(document).on("click", "#AnotherCountryModal .confirmButton", function () {
        $("#AnotherCountryModal").modal("hide");
    });

    $('#AnotherCountryModal').on('hidden.bs.modal', function (e) {
        $("#AnotherCountryModal").remove();
    });
}
//#endregion Lang And Currency

function TopLink() {
    $('.top_link').hide();
    $('.top_link').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

    var showTopLink = 100;
    $(window).scroll(function () {
        if ($('.top_link').length > 0) {

            if ($(window).scrollTop() > showTopLink) {
                $('.top_link').fadeIn('slow');
            } else {
                $('.top_link').fadeOut('slow');
            }
        }
    });
}

function GetInsiderObjectForHome() {
    var cName = $("#CName").val();

    if (cName == "Home") {
        $.ajax({
            type: 'get',
            url: getRequestRoute() + "/p/Home/GetInsiderObjectForHome",
            data: "Cname=" + cName,
            dataType: 'json',
            async: true,
            success: function (dt) {
                window.insider_object = jQuery.parseJSON(dt);
            }
        });
    }
}

$(document).ready(function () {
    TopLink();
    //CountryControlForModal();
    //GetInsiderObjectForHome();

    if (isMobileResolution()) {
        ToggleFooterMenu();
    }

    $(window).resize(function () {
        setContentHeight();
    });

    $(document).on("submit", ".NewsletterForm", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        UserForms(form, function (dt) {
            if (dt.Sonuc == true) {
                GenerateLocalLoading(form, "hide");
                SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
            }
            else {
                var errorMsg = dt.IslemSonucAciklama;

                if (errorMsg == "" || errorMsg == null) {
                    errorMsg = dt;
                }

                SwalGenerate("error", errorMsg, getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
                GenerateLocalLoading(form, "hide");
            }
        });

        return false;
    });

    $(document).on("click", ".errorContainer .SearchArea .input-group-append", function () {
        $(".SearchArea form").trigger("submit");
    });

    if ($(".content-main").length > 0 && $(".swiper-container.main-slider").length > 0) {
        const swiper = new Swiper('.swiper-container.main-slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            autoplay: {
                delay: 3000
            },
            breakpoints: {
                992: {
                    loop: false
                }
            }
        });
    }

    if ($(".content-main").length > 0 && $(".swiper-container.brand-slider").length > 0) {
        const swiper = new Swiper('.swiper-container.brand-slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 3000
            },
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    loop: false,
                    pagination: false
                }
            },
            pagination: {
                el: ".swiper-pagination"
            }
        });
    }
});
